export const isSubscriptionCreator = (offering?: string[]) => {
  return (offering || []).includes('subscription');
};

export const isOtpCreator = (offering?: string[]) => {
  return (offering || []).includes('otp');
};

export const hasPremiumFeaturesOTPIds = (
  customizations?: {
    premiumFeaturesOTPIds?: Array<number | null> | null;
  } | null,
) => {
  return (
    Array.isArray(customizations?.premiumFeaturesOTPIds) &&
    customizations.premiumFeaturesOTPIds.length > 0
  );
};
